
import { createReducer, on } from "@ngrx/store";
import { FetchAIAgentActions } from "./fetch.index";
import { FetchAiAgentState } from "src/app/common/models/ai-agents.model";

let initialState: FetchAiAgentState = {
    data: null,
    isLoading: false,
    error: null
}

export const FetchAiAgentReducer = createReducer(
    initialState,
    on(FetchAIAgentActions.fetchAiAgent, (state): FetchAiAgentState => ({
        ...state,
        isLoading: true,
        error: null
    })),
    on(FetchAIAgentActions.fetchAiAgentSuccess, (state, { response }): FetchAiAgentState => ({
        ...state,
        data: response,
        isLoading: false,
        error: null
    })),
    on(FetchAIAgentActions.fetchAiAgentError, (state, { error }): FetchAiAgentState => ({
        ...state,
        data: null,
        isLoading: false,
        error
    })),
    on(FetchAIAgentActions.fetchAiAgentClear, () => ({
        data: null,
        isLoading: false,
        error: null
    }))
)
